<template>
  <v-text-field v-model="internalValue" v-mask="mask" hide-details class="ma-0 pa-0" solo>
    <template v-slot:append>
      <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <div :style="swatchStyle" v-on="on" />
        </template>
        <v-card>
          <v-card-text class="pa-0">
            <v-color-picker v-model="internalValue" flat />
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'ColorPicker',
  props: ['value'],
  watch: {
    value (val) {
      this.lazyValue = val
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', this.lazyValue)
      }
    },
    color () {
      return this.value
    },
    swatchStyle () {
      return {
        backgroundColor: this.color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: this.menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    }
  },
  data: () => ({
    lazyValue: '',
    mask: '!#XXXXXXXX',
    menu: false
  }),
  created () {
    this.internalValue = this.value
  }
}
</script>

<style scoped lang="scss">

</style>
